// Product tiles — UI-only, ne touche pas au métier.
// Attend que le <select is-product-types> existe ET soit peuplé, puis construit des tuiles.
// Images choisies par mapping tolérant (value exacte, préfixe, sign, label normalisé),
// labels nettoyés, ordre contrôlé, synchro avec le select.

(function () {
  function calcT(key, fallback, vars) {
    var dict = window.__calculatorI18n || {};
    var text = dict[key] != null ? String(dict[key]) : String(fallback == null ? key : fallback);
    if (vars) Object.keys(vars).forEach(function (name) { text = text.split('{' + name + '}').join(String(vars[name])); });
    return text;
  }

  // ===== Helpers =====
  const nextFrame = () => new Promise(r => requestAnimationFrame(r));

  async function waitForSelect(selector, timeoutMs = 8000) {
    const t0 = performance.now();
    let el = document.querySelector(selector);
    while (!el && performance.now() - t0 < timeoutMs) {
      await nextFrame();
      el = document.querySelector(selector);
    }
    return el || null;
  }

  async function waitForOptions(select, minCount = 1, timeoutMs = 8000) {
    const t0 = performance.now();
    while (select.options.length < minCount && performance.now() - t0 < timeoutMs) {
      await nextFrame();
    }
    return select.options.length >= minCount;
  }

  function getProductsFromWindow() {
    try {
      const list = Array.isArray(window.calculatorProducts) ? window.calculatorProducts : [];
      return list.map(p => {
        let img =
          p.tileImage ||
          (p.featured_image && (p.featured_image.src || p.featured_image.url)) ||
          (typeof p.featured_image === 'string' ? p.featured_image : null) ||
          (Array.isArray(p.images) && p.images[0] && (p.images[0].src || p.images[0].url || (typeof p.images[0] === 'string' ? p.images[0] : null))) ||
          null;
        if (img && typeof img === 'string' && img.startsWith('//')) {
          img = 'https:' + img;
        }
        return {
          title: p.displayName || p.title || p.sign || '',
          handle: p.handle || '',
          img,
          sign: (p.sign || '').toString()
        };
      });
    } catch {
      return [];
    }
  }

  function matchProduct(option, products) {
    const val = (option.value || '').toLowerCase().trim();
    const label = (option.text || '').toLowerCase().trim();
    return products.find(p =>
      (p.sign && p.sign.toLowerCase() === val) ||
      (p.handle && p.handle.toLowerCase() === val) ||
      (p.title && p.title.toLowerCase() === label) ||
      (p.sign && p.sign.toLowerCase() === label)
    ) || null;
  }

  // Mise en forme des libellés (remplace _ et /, casse propre)
  function prettyLabel(s) {
    if (!s) return '';
    let t = s.replace(/_/g, ' ').replace(/\s*\/\s*/g, ' / ').trim();
    // Laisse DTF, UVDTF etc. en majuscules, sinon capitalise la 1re lettre
    if (/^[A-Z0-9\s\/-]{2,}$/.test(t)) return t;
    return t.charAt(0).toUpperCase() + t.slice(1).toLowerCase();
  }

  // Normalise en UPPER_SNAKE (pour matcher des familles)
function toSnakeUpper(s) {
  return (s || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')    // supprime accents
    .replace(/[^a-zA-Z0-9]+/g, '_')     // non-alphanum -> _
    .replace(/_+/g, '_')                 // compresse ___ en _
    .replace(/^_+|_+$/g, '')            // trim _
    .toUpperCase();
}


  // Les tuiles suivent l’ordre du <select> (= ordre des blocs Theme Editor).

  // ===== Images par handle (value exacte du <option>) =====
  const IMAGE_BY_VALUE = {
    'impression-dtf-en-planche': "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150",
    'impression-transfert-dtf': "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150",
    'transfert-de-sublimation-en-planche': "https://www.sherpa-transfert.com/cdn/shop/files/19_88872334-c784-41b4-9a72-377f0c2fbf91_610x_crop_center.png?v=1742829582",
    'impression-transfert-uv-dtf-objet': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_1_610x_crop_center.png?v=1759932569",
    'transfert-serigraphique-monochrome-en-planche': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_37_610x_crop_center.png?v=1744275603",
    'transfert-serigraphique-monochrome-couleur': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_38_610x_crop_center.png?v=1744275604",
    'transfert-serigraphique-metallique-or-argent': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_610x_crop_center.png?v=1744275604",
    'transfert-serigraphique-monochrome-fluo': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA-Nouvellespagesproduits_30_cbc9f60f-9eee-4883-b23d-8f050bf90908_610x_crop_center.png?v=1744100532",
    'impression-dtf-softshell-block': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_39_610x_crop_center.png?v=1744275603",
    'impression-dtf-softshell-blockmax-au-metre': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_39_610x_crop_center.png?v=1744275603",
    'impression-dtf-pro-max-en-planche-a2-a3': "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150",
    'impression-dtf-pro-max-metre': "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150",
    'ecusson-sublime-subli-color': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_5cdc9e5f-71ee-409b-a6fa-52350b2f2779_610x_crop_center.png?v=1759932569",
    'SUBLICOLOR': "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_5cdc9e5f-71ee-409b-a6fa-52350b2f2779_610x_crop_center.png?v=1759932569"
  };

  // ===== Images par "famille" (sign ou label normalisé) =====
const IMAGE_BY_SIGN = {
  SUBLICOLOR: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_5cdc9e5f-71ee-409b-a6fa-52350b2f2779_610x_crop_center.png?v=1759932569",
  DTF: "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150",
  SUBLIMATION: "https://www.sherpa-transfert.com/cdn/shop/files/19_88872334-c784-41b4-9a72-377f0c2fbf91_610x_crop_center.png?v=1742829582",
  UVDTF: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_1_610x_crop_center.png?v=1759932569",
  TRANSFERT_SERIGRAPHIQUE_MONOCHROME_EN_PLANCHE: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_37_610x_crop_center.png?v=1744275603",
  TRANSFERT_SERIGRAPHIQUE_MONOCHROME_COULEUR: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_38_610x_crop_center.png?v=1744275604",
  /* les deux variantes pour OR/ARGENT */
  TRANSFERT_SERIGRAPHIQUE_OR__ARGENT: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_610x_crop_center.png?v=1744275604",
  TRANSFERT_SERIGRAPHIQUE_OR_ARGENT:  "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_36_610x_crop_center.png?v=1744275604",
  TRANSFERT_SERIGRAPHIQUE_FLUO: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA-Nouvellespagesproduits_30_cbc9f60f-9eee-4883-b23d-8f050bf90908_610x_crop_center.png?v=1744100532",
  DTF_SOFTSHELL: "https://www.sherpa-transfert.com/cdn/shop/files/SHERPA_-_Nouvelles_pages_produits_39_610x_crop_center.png?v=1744275603",
  DTF_PRO_MAX: "https://www.sherpa-transfert.com/cdn/shop/files/8_64dd07bb-aa96-479e-a3ad-b1dcdfdaabba_610x_crop_center.png?v=1742805150"
};


  // Choix d’image tolérant : value exacte > value préfixe > sign > label normalisé > image produit
  function pickImage({ option, prod }) {
    const val = (option.value || '').trim();
    const txt = (option.text || '').trim();
    const sign = (prod && (prod.sign || '').trim()) || '';

    // 1) match exact par value
    if (IMAGE_BY_VALUE[val]) return IMAGE_BY_VALUE[val];

    // 2) match par préfixe (ex. "impression-transfert-dtf-au-metre" commence par "impression-transfert-dtf")
    for (const key of Object.keys(IMAGE_BY_VALUE)) {
      if (val.startsWith(key)) return IMAGE_BY_VALUE[key];
    }

    // 3) sign (DTF, SUBLIMATION…) ou value option (SUBLICOLOR)
    const signKey = toSnakeUpper(sign || val);
    if (IMAGE_BY_SIGN[signKey]) return IMAGE_BY_SIGN[signKey];

    // 4) label normalisé (au cas où l’option affiche la famille)
    const labelKey = toSnakeUpper(txt);
    if (IMAGE_BY_SIGN[labelKey]) return IMAGE_BY_SIGN[labelKey];

    // 5) fallback: image produit de window.calculatorProducts
    return (prod && prod.img) || null;
  }

  // ===== Init =====
  async function init(selectEl) {
    const SELECT = selectEl || (await waitForSelect('[data-patch-calculator-scope] [is-product-types], [is-product-types]'));
    if (!SELECT) return;

    // Attendre que size-calculator.js ait injecté les options
    const ok = await waitForOptions(SELECT, 1);
    if (!ok) {
      await new Promise(resolve => {
        const obs = new MutationObserver(() => {
          if (SELECT.options.length > 0) { obs.disconnect(); resolve(); }
        });
        obs.observe(SELECT, { childList: true });
        setTimeout(() => { obs.disconnect(); resolve(); }, 8000);
      });
    }

    // Évite double init
    if (SELECT.dataset.tilesReady === '1') return;

    const box = SELECT.closest('.input--box') || SELECT.parentElement;
    if (!box) return;

    // Conteneur des tuiles
    const tilesWrap = document.createElement('div');
    tilesWrap.className = 'product-tiles';
    tilesWrap.setAttribute('is-product-tiles', '');
    box.appendChild(tilesWrap);

    // Produits (pour visuels éventuels + sign)
    const products = getProductsFromWindow();

    // Options du select — garder l’ordre Liquid / Theme Editor (pas de tri forcé)
    const options = Array
      .from(SELECT.options)
      .filter(o => (o.value || '').trim() !== '');

    // Création des tuiles
    const tiles = options.map(option => {
      const prod = matchProduct(option, products);

      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'product-tile';
      tile.setAttribute('role', 'radio');
      tile.setAttribute('aria-checked', option.selected ? 'true' : 'false');
      tile.dataset.value = option.value;

      const imgBox = document.createElement('div');
      imgBox.className = 'product-tile__img';

      const imgSrc = pickImage({ option, prod });

      if (imgSrc) {
        const img = document.createElement('img');
        img.loading = 'lazy';
        img.decoding = 'async';
        img.alt = option.text;
        img.src = imgSrc;
        imgBox.appendChild(img);
      } else {
        imgBox.innerHTML = '<span style="font-size:12px;color:#aaa;text-align:center">' + calcT('preview_unavailable','Aperçu indisponible').replace(' ', '<br>') + '</span>';
      }

      const label = document.createElement('div');
      label.className = 'product-tile__label';
      label.textContent = prettyLabel(option.text);

      tile.appendChild(imgBox);
      tile.appendChild(label);

      // Interaction : clique -> met à jour le select + événement "change"
      tile.addEventListener('click', () => {
        SELECT.value = option.value;
        SELECT.dispatchEvent(new Event('change', { bubbles: true }));
        tiles.forEach(t => t.setAttribute('aria-checked', 'false'));
        tile.setAttribute('aria-checked', 'true');
      });

      tilesWrap.appendChild(tile);
      return tile;
    });

    // Synchronisation si la valeur du select change depuis le JS métier
    SELECT.addEventListener('change', () => {
      const v = SELECT.value;
      tiles.forEach(t => t.setAttribute('aria-checked', t.dataset.value === v ? 'true' : 'false'));
    });

    // Masquer UNIQUEMENT le select des PRODUITS (sans impacter "Délai de production")
    const wrap = SELECT.closest('.select--wrap') || SELECT.parentElement;
    if (wrap) {
      wrap.style.position = 'absolute';
      wrap.style.inset = '0';
      wrap.style.pointerEvents = 'none';
      SELECT.style.opacity = '0';
      SELECT.style.width = '1px';
      SELECT.style.height = '1px';
    }

    SELECT.dataset.tilesReady = '1';
  }

  function resetProductTiles(select) {
    if (!select) return;
    delete select.dataset.tilesReady;
    var box = select.closest('.input--box') || select.parentElement;
    if (!box) return;
    var oldTiles = box.querySelector('[is-product-tiles]');
    if (oldTiles) oldTiles.remove();
  }

  // Lancer après DOM prêt + quelques relances si l’injection est tardive
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  setTimeout(init, 1500);
  document.addEventListener('patch-calculator:products-ready', function (event) {
    var select = event.detail && event.detail.select;
    resetProductTiles(select);
    init(select);
  });
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 100);
  });
  setTimeout(init, 4000);
})();